export default __webpack_public_path__ + "static/media/Array-Concatenate.5ef76e12.svg";